import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import state from "./state";

const crossSellingStore = {
  state,
  getters,
  mutations,
  actions,
};

export default crossSellingStore;
